module.exports = "<div ng-class=\"['dropdown align-tb', {opened: $ctrl.opened}]\" ng-click=\"$ctrl.toggleSelectDropdown()\">\n    <span class=\"dropdown-text\">{{$ctrl.label}}</span>\n    <i class=\"icon ico-arrow-down\"></i>\n</div>\n<!-- .dropdown END -->\n\n<div class=\"dropdown-popup\" ng-transclude=\"dropdown\">\n\n</div>\n<!-- .dropdown-popup END -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpSelectDropdown/adpSelectDropdown.html
// module id = 579
// module chunks = 0